import type { Boards } from '../../model/index.tsx';
import getAssociatedBoards from '../../rest/get-associated-boards/index.tsx';
import { transformResponse } from './transformers.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (filterId: string): Promise<Boards> => {
	const response = await getAssociatedBoards(filterId);
	return transformResponse(response);
};
